export enum ManifestActionType {
    START_REQUEST = 'START_REQUEST',
    END_REQUEST = 'END_REQUEST',
    SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL'
}
